import nextOrPrevAll from "./_internal/_nextOrPrevAll.js";

export default nextOrPrevAll("parentNode", "push");
